import { Component } from '@angular/core';
import { GenericListView } from '../../../infrastructure/infrastructure-services/generics/genericlistview/generic-list-view';
import { GenericService } from '../../../infrastructure/infrastructure-services/services/base/generic-service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteDialogComponent } from '../branches-listview/confirm-delete-dialog/confirm-delete-dialog.component';
import { enumBPMaster, enumObjectType } from 'src/app/infrastructure/infrastructure-services/common/common-enums';
import { WrapperStandardFilter } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
import { map } from 'rxjs';
import { IBPMasterModel } from 'src/app/core/models/masters/bp-master.model';
import { SecurityService } from 'src/app/login-layout/Service/security.service';

@Component({
  selector: 'app-business-partner-master-listview',
  templateUrl: './business-partner-master-listview.component.html',
  styleUrls: ['./business-partner-master-listview.component.css']
})

export class BusinessPartnerMasterListviewComponent extends GenericListView<IBPMasterModel> {
  auser: any
  
  canAdd: boolean = true;
  canEdit: boolean = true;
  canView: boolean = true;
  isActiveMenu: boolean = true;

  checkMenuPermissions() {
    let securityService = new SecurityService();
    let permissions = securityService.getMenuPermissions(this.getFormSubTitle);
    this.canAdd = permissions.canAdd;
    this.canEdit = permissions.canEdit;
    this.canView = permissions.canView;
    this.isActiveMenu = permissions.isActive;
  }

  constructor(agenericRepository: GenericService<IBPMasterModel>, router: Router, public dialog: MatDialog, private activatedRoute: ActivatedRoute) {
    super(agenericRepository, router);    

  //   let state = this.activatedRoute.paramMap.pipe(map(() => window.history.state))
    let state = this.activatedRoute.paramMap.pipe(map(() => window.history.state))
    this.setObjectType = this.activatedRoute.snapshot.data['ObjType'];
    this.setFormTitle = this.getObjectType == enumObjectType.Customer ? "Sales" : this.getObjectType == enumObjectType.Vendor ? "Purchase" : "CRM";
    this.setFormSubTitle = this.getObjectType == enumObjectType.Customer ? "Customer Master" : this.getObjectType == enumObjectType.Vendor ? "Vendor Master" : "Lead Master";
    this.checkMenuPermissions();
    this.setMenuCode = "";
    this.setEntryFormRouteTo = this.getObjectType == enumObjectType.Customer ? "/home/settings/bpmasterentryform/" : this.getObjectType == enumObjectType.Vendor ? "/home/settings/vendormasterentryform/" :"/home/settings/leadmasterentryform/"
    this.setListViewDataSourceURL = "BusinessPartner/GetBusinessPartnerListService";
    this.setDisplayedColumnsNamesList = ['cardCode', 'cardName',  'groupName','validName', 'action'];

    this.getRequestData.SortColumn = "cardCode";
    let filter = new WrapperStandardFilter();
    filter.Key = 'CardType';
    filter.OperatorType = "contains";
    filter.Value = this.getObjectType == enumObjectType.Customer ? enumBPMaster.Customer : this.getObjectType == enumObjectType.Vendor ? enumBPMaster.Vendor : enumBPMaster.Lead;
    this.setFilterArray = filter;
    this.PopulateListView();
  }
  openDialog() {//temp
    const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
}

//


